import React from 'react';
import './_changeLog.scss';
import { CloseRounded } from '@mui/icons-material';

const ChangeLogDrawerHeader = ({ title, onClose }) => {
  return (
    <div className="change-log-drawer-header">
      <p className="change-log-drawer-header-title">{title}</p>
      <CloseRounded className="back-button " onClick={onClose} />
    </div>
  );
};

export default ChangeLogDrawerHeader;
